import { GGCoinError } from "@developerz.ai/ggcoin-sdk";

/** Translate an SDK error into a user-readable line. */
export function describeError(err: unknown): string {
  if (err instanceof GGCoinError) {
    switch (err.code) {
      case "INVALID_CREDENTIALS":
        return "That email, password, or TOTP code didn't check out.";
      case "ACCOUNT_EXISTS":
        return "An account already exists for that email.";
      case "TOTP_NOT_ENROLLED":
        return "Finish your 2FA setup before signing in.";
      case "TOTP_ALREADY_ENROLLED":
        return "2FA is already set up for this account.";
      case "WEAK_PASSWORD":
        return "Pick a stronger password.";
      case "UNAUTHENTICATED":
        return "Your session expired. Please sign in again.";
      case "WALLET_NOT_FOUND":
        return "We couldn't find that wallet.";
      case "WALLET_FROZEN":
        return "This wallet is frozen.";
      case "WALLET_OPERATOR_LOCKED":
        return "This wallet was frozen by support and can't be unfrozen here — contact support.";
      case "NETWORK_ERROR":
        return "Network problem — check your connection and try again.";
      default:
        return err.message || `Request failed (${err.code}).`;
    }
  }
  if (err instanceof Error) return err.message;
  return "Something went wrong.";
}
